import axios from "axios";

export default {
  openReservationById(supplierId, reservationId) {
    return axios.get("api/reservation/FindReservationBySupplier", {
      params: { supplierId, reservationId }
    });
  }
};


// WEBPACK FOOTER //
// ./src/api/reservation/reservationService.js